var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-colored-el",
    fill: "#06CF7F",
    d: "M2.215 3.083L4.615.18a.5.5 0 11.77.638L2.22 4.645.617 2.735a.5.5 0 11.766-.643l.832.99z"
  })));
};
export default SvgCheckIcon;